<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>信箱评论列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">信箱编号：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入信箱编号" style="width:400px;" v-model="subData.mailId"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">留言用户编号：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入留言用户编号" style="width:400px;" v-model="subData.readUserId"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">留言内容：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入留言内容" style="width:400px;" v-model="subData.commentMsg"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">留言时间：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入留言时间" style="width:400px;" v-model="subData.createdTime"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">是否已读，0=未度，1=已读：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入是否已读，0=未度，1=已读" style="width:400px;" v-model="subData.isRead"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">状态，0=显示，1=不显示：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入状态，0=显示，1=不显示" style="width:400px;" v-model="subData.state"></el-input>
			</el-col>
		</el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
		mailId : '',
		readUserId : '',
		commentMsg : '',
		createdTime : '',
		isRead : '',
		state : '',

      }
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/MailComments/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;

      ths.$post('/MailComments/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/MailCommentsList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>